import type { SinkTable } from './SinkTable.ts'

const MAX_FRACTION_DIGITS = 2

const format = (value: string | number | null, numeric?: boolean): string => {
  if (value === null || value === undefined) return '—'
  if (!numeric || typeof value !== 'number') return String(value)
  return value.toLocaleString(undefined, { maximumFractionDigits: MAX_FRACTION_DIGITS })
}

/**
 * The numbers behind a sink. Deliberately not virtualised: a breakdown is a few dozen rows and a
 * matrix is bounded by the series the chart itself draws, so the full table is what gets exported.
 */
export const SinkTableView = ({ table }: { table: SinkTable }) => {
  if (table.rows.length === 0) {
    return <div className="p-3 text-sm opacity-70">No numbers for the current selection.</div>
  }

  return (
    <div className="h-full overflow-auto p-2" data-testid="sink-table">
      {table.caption && <div className="text-xs opacity-60 pb-2">{table.caption}</div>}
      <table className="table table-xs table-pin-rows">
        <thead>
          <tr>
            {table.columns.map((column) => (
              <th key={column.key} className={column.numeric ? 'text-right' : ''}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, index) => (
            <tr key={index}>
              {table.columns.map((column) => (
                <td key={column.key} className={column.numeric ? 'text-right tabular-nums' : ''}>
                  {format(row[column.key], column.numeric)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
